import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const GLASS_BG = 'rgba(16, 18, 27, 0.85)';
const GLASS_BORDER = 'rgba(255, 255, 255, 0.08)';

/**
 * GlassSidebar - Glassmorphism sidebar component for modern UI
 * Provides a translucent sidebar with blur effect matching the industrial UI theme
 */
const StyledSidebar = styled(Box)(({ _theme, width = 280 }) => ({
    background: GLASS_BG,
    backdropFilter: 'blur(12px)',
    border: `1px solid ${GLASS_BORDER}`,
    borderRadius: '0 16px 16px 0',
    color: '#fff',
    width: width,
    minWidth: width,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    boxShadow: '4px 0 24px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.3s ease',
}));

const GlassSidebar = ({ children, width = 280, ...props }) => {
    return (
        <StyledSidebar width={width} {...props}>
            {children}
        </StyledSidebar>
    );
};

export default React.memo(GlassSidebar);
